import Chip from "@mui/material/Chip";
import React from "react";

import { RequoteBadge, versionChipSx } from "./RequoteBadge";

import type { QuoteVersionState } from "./RequoteBadge";
import type {
  Proposal,
  ProposalPlanGroup,
} from "../../../../types/proposal.types";
import type { CustomHeaderGroupProps } from "ag-grid-react";

/**
 * VersionRowHeader renders the "Version" tier of the carrier-grouped SBS grid (ADR-031),
 * in three cases keyed on what actually backs the column:
 *
 *   - no backing proposal → "Current", the synthetic incumbent/requested baseline
 *   - a proposal with no quote version → blank, an awaiting-quote placeholder column
 *     (ADR-024). It must not read "Current", which would claim it is the incumbent plan.
 *   - a proposal with a quote version → the version chip + received timestamp
 */
const VersionRowHeader = (props: CustomHeaderGroupProps): React.JSX.Element => {
  const colGroupDef = props.columnGroup
    .getProvidedColumnGroup()
    .getColGroupDef();
  const params = (colGroupDef?.headerGroupComponentParams ?? {}) as {
    proposalId?: Proposal["id"];
    quoteVersion?: ProposalPlanGroup["carrierQuoteVersion"];
    receivedAt?: Proposal["receivedAt"];
    versionState?: QuoteVersionState;
  };

  return (
    <div
      className="ag-header-group-cell-label"
      style={{ width: "100%", display: "flex", justifyContent: "center" }}
    >
      {params.proposalId === undefined ? (
        <Chip label="Current" size="small" sx={versionChipSx} />
      ) : params.quoteVersion === undefined ? null : (
        <RequoteBadge
          quoteVersion={params.quoteVersion}
          receivedAt={params.receivedAt}
          state={params.versionState}
        />
      )}
    </div>
  );
};

VersionRowHeader.displayName = "VersionRowHeader";
export default VersionRowHeader;
